import { render } from "./ItemAddlist.vue?vue&type=template&id=614027a7"
import script from "./ItemAddlist.vue?vue&type=script&lang=js"
export * from "./ItemAddlist.vue?vue&type=script&lang=js"

import "./ItemAddlist.vue?vue&type=style&index=0&id=614027a7&lang=css"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__